<template>
  <v-container class="filter py-0">
    <template v-for="category in categories">
      <v-col cols="12" :key="`${category._id}_cat`" class="pa-0">
        <v-checkbox
          v-model="activeCategories"
          :label="category.name"
          :value="category"
          @change="filterCategories()"
          hide-details
          off-icon="fa fa-square"
          :dark="dark"
        />
      </v-col>
      <v-col cols="12" :key="`${category._id}_subcat`" class="pa-0">
        <v-slide-y-transition>
          <div class="subcategory-container py-0" v-show="activeCategories.includes(category)">
            <v-checkbox
              v-for="(subcategory, index) in category.subcategories"
              :key="index"
              v-model="subcategory.active"
              :label="subcategory.name"
              :value="subcategory.name"
              @change="filterCategories()"
              hide-details
              off-icon="fa fa-square"
              :dark="dark"
            />
          </div>
        </v-slide-y-transition>
      </v-col>
    </template>
    <v-col cols="12" key="transit_cat" class="pa-0">
      <v-checkbox
        v-model="activeCategories"
        label="Transit"
        value="transit"
        @change="filterCategories()"
        class="category"
        hide-details
        off-icon="fa fa-square"
        :dark="dark"
      />
    </v-col>
    <v-col cols="12" key="emergencyPhone_cat" class="pa-0">
      <v-checkbox
        v-model="activeCategories"
        label="Emergency Phones"
        value="emergencyPhones"
        @change="filterCategories()"
        class="category"
        hide-details
        off-icon="fa fa-square"
        :dark="dark"
      />
    </v-col>
  </v-container>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'

export default {
  name: 'LocationFilter',
  props: {
    dark: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      activeCategories: []
    }
  },
  computed: {
    ...mapGetters({
      categoriesInitial: 'categories'
    }),
    categories () {
      return this.categoriesInitial.map(categoryIn => {
        const category = Object.assign({}, categoryIn)

        category.subcategories = category.subcategories.map(subcategory => {
          return {
            name: `${subcategory}`, // Deep clone the name
            active: false
          }
        })

        return category
      })
    }
  },
  methods: {
    ...mapMutations([
      'setFilteredCategories'
    ]),
    filterCategories () {
      this.setFilteredCategories(this.activeCategories)
    }
  }
}
</script>

<style scoped lang="scss">
.subcategory-container {
  padding-left: 20px;
}

.filter {
  & > .col:first-child .v-input {
    margin-top: 0
  }
}
</style>
